import { colors, Grid, styled, Typography } from '@mui/material';

import { useEffect, useMemo, useState } from 'react';
import Image from '~/components/Image';
import { Brand, brands } from '.';
import { useScreenSize } from '~/hooks/useScreenSize';

export const BrandsBanner = () => {
  const count = 5;
  const randomizedBrands = useMemo(() => [...brands], []); //.sort(() => Math.random() - 0.5);
  const [logos, setLogos] = useState<Brand[]>(randomizedBrands.slice(0, count));
  const [currentIndex, setCurrentIndex] = useState(count);
  const { mdAndUp } = useScreenSize();

  useEffect(() => {
    const interval = setInterval(() => {
      setLogos((prevLogos) => {
        const newLogos = [...prevLogos];
        const newIndex = currentIndex % count;
        const newBrand = randomizedBrands[newIndex % randomizedBrands.length];
        if (newBrand) {
          newLogos[newIndex] = newBrand;
        }

        setCurrentIndex(
          (prevIndex) => (prevIndex + 1) % randomizedBrands.length
        );

        return newLogos;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [randomizedBrands, currentIndex]);

  return (
    <Grid
      container
      sx={{ backgroundColor: colors.grey['100'], py: 1 }}
      justifyContent={'space-evenly'}>
      <Grid
        item
        xs={12}
        md={2}
        justifyContent={'center'}
        alignContent={'center'}
        alignItems={'center'}>
        <Typography variant="body1" textAlign={'center'} fontWeight={'light'}>
          Some of our{mdAndUp && <br />} customers {mdAndUp && <br />}❤️
        </Typography>
      </Grid>
      {logos.map((brand) => {
        return (
          <Grid
            item
            xs={4}
            md={2}
            key={brand.name}
            justifyContent={'center'}
            alignContent={'center'}
            alignItems={'center'}
            display="flex">
            <StyledImage
              src={`${import.meta.env.VITE_STATIC_ASSETS_URL}/brands/${
                brand.logo
              }`}
              alt={brand.name}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

const StyledImage = styled(Image)`
  object-fit: contain;
  height: 128px;
  width: 128px;
`;
